import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "48px",
  background: "#FFF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
    gap: "40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "24px",
  width: "100%",
  minWidth: "282px",
  padding: "16px 24px",
  borderRadius: "8px",
  background: "#EFEFFD",

  [props.theme.breakpoints.down("lg")]: {
    minHeight: "182px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "16px",
  },
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  justifyContent: "center",
  width: "100%",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
    // maxWidth: "392px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "none",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  width: "100%",
  maxWidth: "1200px",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  alignSelf: "stretch",
  maxWidth: "950px",
  margin: "0 auto",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22.4px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)", // 4 per row
  maxWidth: "1200px",
  gap: "40px",
  justifyContent: "center",
  alignItems: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    flexWrap: "nowrap",
    maxWidth: "100%",
    justifyContent: "flex-start",
    gridTemplateColumns: "repeat(1, 1fr)",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "200px",
  maxWidth: "200px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "100px",
    maxWidth: "100px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "16px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "unset",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "16px" : "24px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 400,
  lineHeight: props.type == "desc" ? "24px" : "36px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.15px" : "0.036px",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "16px" : "20px",
    lineHeight: props.type == "desc" ? "24px" : "30px",
    letterSpacing: props.type == "desc" ? "0.15px" : "0.03px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "22.4px",
    letterSpacing: props.type == "desc" ? "unset" : "unset",
  },
}));

export const LineBreak = styling("div")((props) => ({
  width: "1px",
  backgroundColor: "#000",
  margin: "0",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    height: "1px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  height: "56px",
  padding: "0px 40px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "8px",
  color: "rgba(0,0,0,0.87)",
  boxShadow: "0px 2px 4px 0px rgba(104, 77, 0, 0.40)",
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: "20px",
  fontWeight: 700,
  fontStyle: "normal",
  lineHeight: "120%",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  background: "#FFDA07",
  minWidth: "280px",
  width: "fit-content",

  "&:hover": {
    backgroundColor: "#FFDA07",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "1rem",
    lineHeight: "150%",
    letterSpacing: "0.1px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "280px",
    paddingInline: "1rem",
    height: "48px",
  },
}));
